/* =======================================================================
   Layout — Cornice condivisa da tutte le pagine
   =======================================================================
   Tutte le pagine sono "incorniciate" dallo stesso Header (menu in alto)
   e Footer (piè di pagina). <Outlet /> è il posto dove appare il contenuto
   della pagina corrente (Home, Storia, Menù, ecc.).
   ======================================================================= */
import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import copy from "@/data/copy";

export default function Layout() {
  return (
    <div data-testid="site-layout" className="bg-[#F7F4EB] text-[#2C2C2A] min-h-screen flex flex-col">
      <Header copy={copy} />
      <main data-testid="site-main" className="flex-1">
        <Outlet />
      </main>
      <Footer copy={copy} />
    </div>
  );
}
